import { combineReducers } from 'redux';

import errorMessage from './errorMessage';
import entities from './entities';
import mySyndicates from './mySyndicates';
import currentSyndicate from './currentSyndicate';
import memberSyndicates from './memberSyndicates';

const rootReducer = combineReducers({
  errorMessage,
  entities,
  mySyndicates,
  memberSyndicates,
  currentSyndicate
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js